export default "__VITE_ASSET__DTTnVA4K__"